/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerieSerieidLangsQueryResponse,
  GetApiV1SerieSerieidLangsPathParams,
  GetApiV1SerieSerieidLangsQueryParams,
  GetApiV1SerieSerieidLangs401,
  GetApiV1SerieSerieidLangs404,
  GetApiV1SerieSerieidLangs500,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangs.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerieSerieidLangs } from "../../clients/serieIdiomasController/getApiV1SerieSerieidLangs.ts";

export const getApiV1SerieSerieidLangsQueryKey = (
  serieId: GetApiV1SerieSerieidLangsPathParams["serieId"],
  params?: GetApiV1SerieSerieidLangsQueryParams,
) =>
  [
    { url: "/api/v1/serie/:serieId/langs", params: { serieId: serieId } },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1SerieSerieidLangsQueryKey = ReturnType<
  typeof getApiV1SerieSerieidLangsQueryKey
>;

export function getApiV1SerieSerieidLangsQueryOptions(
  serieId: GetApiV1SerieSerieidLangsPathParams["serieId"],
  params?: GetApiV1SerieSerieidLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerieSerieidLangsQueryKey(serieId, params);
  return queryOptions<
    GetApiV1SerieSerieidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangs401
      | GetApiV1SerieSerieidLangs404
      | GetApiV1SerieSerieidLangs500
    >,
    GetApiV1SerieSerieidLangsQueryResponse,
    typeof queryKey
  >({
    enabled: !!serieId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerieSerieidLangs(serieId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de traduções (idiomas) de uma série. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs}
 */
export function useGetApiV1SerieSerieidLangs<
  TData = GetApiV1SerieSerieidLangsQueryResponse,
  TQueryData = GetApiV1SerieSerieidLangsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerieSerieidLangsQueryKey,
>(
  serieId: GetApiV1SerieSerieidLangsPathParams["serieId"],
  params?: GetApiV1SerieSerieidLangsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerieSerieidLangsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerieSerieidLangs401
          | GetApiV1SerieSerieidLangs404
          | GetApiV1SerieSerieidLangs500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerieSerieidLangsQueryKey(serieId, params);

  const query = useQuery(
    {
      ...getApiV1SerieSerieidLangsQueryOptions(serieId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangs401
      | GetApiV1SerieSerieidLangs404
      | GetApiV1SerieSerieidLangs500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
